import httpClient from 'shared/lib/httpClient';
import { parseCountryList } from '../schemas/MasterDataSchema';

export const getCountryList = async (params) => {
  const response = await httpClient.get('/countries', { params });
  return parseCountryList(response?.data);
};
